export default __webpack_public_path__ + "static/media/notifications-icon.a9a67523.svg";